"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookiesConsentContext = void 0;
const react_1 = require("react");
exports.CookiesConsentContext = (0, react_1.createContext)(
// We don't really want a default value, but createContext requires one,
// and TypeScript expect it to have correct type.
undefined);
//# sourceMappingURL=CookiesConsentContext.js.map